module.exports = "/assets/data/8c2b7bf96b971d4f47591fa90a1ceaf4-GU26.data.json";